import React from "react";
import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { makeStyles } from "@material-ui/core/styles";
import ListItemIcon from "@material-ui/core/ListItemIcon";

import { withRouter } from "react-router-dom";

import LinkIcon from "@material-ui/icons/Link";
import CodeIcon from "@material-ui/icons/Code";
import OfflineBoltIcon from "@material-ui/icons/OfflineBolt";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  but: {
    textTransform: "capitalize",
    fontSize: "16px",
    fontFamily: "Accura",
    fontWeight: "bold",
    color: "#58585a",
    "&:hover": {
      color: "#fff",
      backgroundColor: "transparent",
    },
  },
}));

const MenuListComposition = (props) => {
  const { history } = props;
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleClick = (event) => {
    setOpen(event.currentTarget);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleMenuClick = (pageURL) => {
    history.push(pageURL);
    setOpen(false);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <div className={classes.root}>
      <div>
        <Button
          ref={anchorRef}
          aria-controls={open ? "menu-list-grow" : undefined}
          aria-haspopup="true"
          //   onClick={handleToggle}
          className={classes.but}
          onMouseOver={handleClick}
          onClick={() => handleMenuClick("/servicios")}
        >
          Servicios
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              onMouseLeave={handleClose}
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={false}
                    id="menu-list-grow"
                    onKeyDown={handleListKeyDown}
                  >
                    <MenuItem
                      onClick={() => handleMenuClick("/servicios#boton")}
                    >
                      <ListItemIcon>
                        <OfflineBoltIcon fontSize="small" />
                      </ListItemIcon>
                      Botón de pago
                    </MenuItem>
                    <MenuItem
                      onClick={() => handleMenuClick("/servicios#link")}
                    >
                      <ListItemIcon>
                        <LinkIcon fontSize="small" />
                      </ListItemIcon>
                      Link de pago
                    </MenuItem>
                    <MenuItem onClick={() => handleMenuClick("/servicios#api")}>
                      <ListItemIcon>
                        <CodeIcon fontSize="small" />
                      </ListItemIcon>
                      API
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  );
};

export default withRouter(MenuListComposition);
